import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_t2bh3wmq82: FaireBrandEntity = {
  token: "b_t2bh3wmq82",
  type: "brand",
  name: "Aquamarine Daydream Wholesale",
  avatarUrl:
    "https://cdn.faire.com/fastly/f35603a596b4b65c0a72745c84a2589f7bbb82627796682f1d28969c4dc8704c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5a0567d341ac9bd450a5afd5c2157a760dacca9ddd04963c22397db0872e3d12.png",
  logoUrl:
    "https://cdn.faire.com/fastly/f35603a596b4b65c0a72745c84a2589f7bbb82627796682f1d28969c4dc8704c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5a0567d341ac9bd450a5afd5c2157a760dacca9ddd04963c22397db0872e3d12.png",
  location: "Tucson, AZ, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 33,
  isInsider: true,
  description:
    "WAREHOUSE HOURS: Tuesday-Friday 9AM-5PM MST\nAquamarine Daydream specializes in a diverse range of products, including crystals and minerals, jewelry, fossils, tarot, books, home décor, and self-care items. Our team takes pride in our expertise in both metaphysics and geological science. Our establishment is proudly owned and operated by women and members of the LGBTQ+ community. Aquamarine Daydream operates three locations in Tucson, Arizona: a retail store located on Historic 4th Avenue, a wholesale warehouse that is open year-round, and also participates in the 1820 Oracle Wholesale Show, which takes place during the gem show.\n\nThe Owner, Lovisa, grew up in Oregon. She began her entrepreneurial journey by creating hemp jewelry with gemstone beads and hand-sewing hacky sacks filled with herbal and crystal surprises, selling her products at festivals. The business quickly expanded to Etsy and Facebook, evolving into a full-time venture. During the pandemic, supply chain challenges motivated her to relocate to Tucson, home of the world's largest gem show. While searching for a warehouse to facilitate online sales, she discovered a charming storefront on Historic Fourth Avenue in downtown Tucson and took the leap into opening a brick and mortar location. Since then, the business has proudly grown to become a trusted and respected name within the mineral industry.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:56.069Z",
    importedBy: "entity-db-cli",
  },
};
